import styled from '@emotion/styled'

import {Text} from '@vio/atlas/Text'

export const HomePageSectionTitle = styled(Text)`
  &.--center {
    text-align: center;
  }
`
